<!--
Displays availability times for a location.

@author cm359n

-->
<template>
  <div class="availabilityList">
      <div v-if="noFreeSlots">
          This room is unavailable {{ dayString() }}.
      </div>
      <div v-if="!noFreeSlots">This room has the following availability {{ dayString() }}:</div>
      <table class="availability">
          <tr :class="slot.status + 'avail'" class="" v-bind:key="slot.name" v-for="slot in slots">
              <td v-if="slot.status == ''">{{slot.name}}</td>
              <td v-if="slot.status != ''">{{slot.name}}</td>
              <td>{{slot.status}}</td>
          </tr>
      </table>

  </div>
</template>

<script setup>
//Utilities
import {ref, onMounted} from 'vue'
import axios from 'axios'

//Composables
import {useStringUtil} from '@/composables/StringMethods.js'
const {range, nextHalfHour} = useStringUtil()


const props = defineProps({
  day: Number,
  startingSlot: String,
  location: String,
  bookingConstraint: Object,
  fakeTime: String
})

//Data
const startTime = ref('')
const endTime = ref('')
const slots = ref([])
const noFreeSlots = ref(true)

onMounted(
  () => {
    fetchAvailability()
  }
)


function dayString () {
  switch (props.day) {
    case 0:
      return 'today'
    case 1:
      return 'tomorrow'
    default:
      return props.day + ' days from now'
  }
}

function pickSlot (slot) {
  console.log('half hour slot ' + slot + ' picked')
}

function fetchAvailability () {
  console.log(props.location)
  console.log(props.day)
  axios.get('/timetable/bookingv2/slots', {
    params: {
      locationId: props.location,
      days: props.day
    }
  })
    .then(response => {
      if (typeof response.data !== 'undefined') {
        calculateSlots(response.data)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function newDate () {
  let d = new Date()
  if (typeof props.fakeTime !== 'undefined' && props.fakeTime != '') {
    const hhmm = props.fakeTime.split(':')
    d.setHours(parseInt(hhmm[0]))
    d.setMinutes(parseInt(hhmm[1]))
    d.setSeconds(0)
    d.setMilliseconds(0)
  }
  return d
}

function calculateSlots (bs) {
  startTime.value = props.bookingConstraint.minTime
  endTime.value = props.bookingConstraint.maxTime
  slots.value = []
  let startingSlot = startTime.value
  if (props.day == 0 && typeof props.startingSlot !== 'undefined' && props.startingSlot != '') {
    startingSlot = props.startingSlot
  }
  let totalslots = 0
  let bookedslots = 0
  for (const slot of range(hourPortion(startingSlot), hourPortion(endTime.value))) {
    // console.log('looking at time slot ' + slot.value)
    const slotstart = slot.value
    const slotend = nextHalfHour(slot.value)
    let obj = { 'name': slotstart, status: '' }

    for (const bookedSlot of bs) {
      const bsStart = bookedSlot.startTime
      const bsEnd = bookedSlot.finishTime
      // console.log('comparing bookedSlot [' + bsStart + '-' + bsEnd + '] to [' + slotstart + '-' + slotend + ']')
      if (slotstart < bsEnd && slotend > bsStart) {
        obj.status = 'BOOKED'
        bookedslots++
      }
    }
    if (obj.status == '') {
      noFreeSlots.value = false
    }
    slots.value.push(obj)
    totalslots++
  }
  if (totalslots == bookedslots) {
    noFreeSlots.value = true
  }
}

function hourPortion (str) {
  // console.log('splitting ' + str + ' which is a ' + typeof str)
  let hhmm = str.split(':')
  return parseInt(hhmm[0])
}

</script>

<style>
table.availability {
        width: 90%;
    border: 1px solid gray;
}
table.availability tr td {
    padding-left: 10px;
    padding-right: 10px;
    min-width: 180px;
    font-size: small;
}
table.availability tr:nth-child(even) {
    background: #ffffff;
}

table.availability tr:nth-child(odd) {
    background: #eef3ff;
}

tr.BOOKEDavail td {
    color: #9d9ca8;
}
tr.avail td {
    font-weight: bold;
}
</style>
